<template>
  <div class="app">
    <el-row>
      <el-col :span="4">
        <!--左侧导航组件-->
        <navmenu></navmenu>
      </el-col>
      <el-col :span="20">
        <div style="position: relative">
          <!--右侧头部背景、登录状态、推出登录组件-->
          <navheader> </navheader>
          <img class="img" :src="$store.state.logoUrl" alt="" />
        </div>
        <!-- 右侧内容组件 -->
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {} from "../assets/js/network/network.js";
import navmenu from "../components/navmenu";
import navheader from "../components/NavHeader";
import { organizationLogo } from "../assets/js/network/network.js";
export default {
  name: "index",
  components: {
    navmenu,
    navheader,
  },
  data() {
    return {
      login_logo: "",
    };
  },
  methods: {},
  computed:{},
  mounted() {
     if(this.$store.state.logoUrl){
       this.login_logo = this.$store.state.logoUrl
     }else {
       organizationLogo({  }).then((res) => {
         this.login_logo = res.ret.login_logo;
         this.$store.commit('setLogoUrl', this.login_logo)
       });
     }
    // console.log(this.$store.commit('setLogoUrl'))
  },

};
</script>
<style scoped>
@import "../style/common.css";

.app {
  width: 100%;
  height: 100vh;
}
.img {
  position: absolute;
  height: 34px;
  top: 50%;
  margin-top: -16px;
  left: 30px;
}
</style>
